// 认领模型所属用户信息
export const claimModel = (modelId: string) =>
  useGet(
    `/api/v1/model-library-server/model-claim/userInfo?modelId=${modelId}`
  );

// 生成验证码
export const generateCode = (params: { url: string }) =>
  usePost(`/api/v1/model-library-server/model-claim/generate-code`, params);

// 验证链接-认领
export const claimLink = (linkId: string, modelId: string) =>
  usePost(
    `/api/v1/model-library-server/model-claim/${linkId}/verify/${modelId}`
  );

// 模型列表
export const getModelList = (modelId: string, linkId?: string) =>
  useGet(
    `/api/v1/model-library-server/model-claim/list?modelId=${modelId}${
      linkId ? `&linkId=${linkId}` : ""
    }`
  );

// 批量认领
export const claimBatch = (params: { ids: number[] }) =>
  usePost("/api/v1/model-library-server/model-claim/batch", params);

// 查询进度
export const getClaimProgress = () =>
  useGet("/api/v1/model-library-server/model-claim/process");

// 关联状态
export const getClaimStatus = (modelId: string) =>
  useGet(
    `/api/v1/model-library-server/model-claim/linkStatus?modelId=${modelId}`
  );
